module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige11-2c19e52c95750a1008d6b67d7862ee57.jpg";